import src from "IMAGE";
export default { src, width: 200, height: 33, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AMMZGaapEhKVmg4OiyEREUIREhJoGBgZdBwdHXcZGRlqkU4HoMER6hEAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
